import React, { useMemo } from 'react';
import { ConfigBasic } from 'new/components/settings/VendorBuilder/AuthConfig/ConfigBasic';
import { ConfigToken } from 'new/components/settings/VendorBuilder/AuthConfig/ConfigToken';
import { ConfigApiKey } from 'new/components/settings/VendorBuilder/AuthConfig/ConfigApiKey';
import { ConfigOAuth1 } from 'new/components/settings/VendorBuilder/AuthConfig/ConfigOAuth1';
import { ConfigOAuth2 } from 'new/components/settings/VendorBuilder/AuthConfig/ConfigOAuth2';
import { ConfigAWS } from 'new/components/settings/VendorBuilder/AuthConfig/ConfigAWS';
import { Section } from 'new/components/settings/VendorBuilder/components/Section';
import { DynamicConfigValues } from 'new/components/settings/VendorBuilder/DynamicConfigValues';
import Typography from 'new/elements/Typography';
import { FormBuilder } from 'new/components/settings/VendorBuilder/FormControlBuilder';
interface TemplateConfigProps {
  type: keyof typeof components;
  index: number;
}

const components = {
  BASIC: ConfigBasic,
  TOKEN: ConfigToken,
  API_KEY: ConfigApiKey,
  OAUTH1: ConfigOAuth1,
  OAUTH2: ConfigOAuth2,
  AWS_SIGNATURE: ConfigAWS,
};

const fields = (index) => [
  // {
  //   type: 'text',
  //   name: `auth_templates[${index}].config["info_url"]`,
  //   label: 'Info URL',
  //   description: 'URL containing information about the authentication type'
  // }
];

export const AuthTemplateDynamicConfig = (props: TemplateConfigProps) => {
  const { type, ...rest } = props;
  const Component = components[type];
  const authTemplateFields = useMemo(() => fields(props.index), [props.index]);
  return (
    <Section
      title={
        <div>
          Template #{props.index + 1}: Config <code>auth_template[].config</code>
        </div>
      }
      gap="16px"
    >
      <Explanation />
      <FormBuilder fields={authTemplateFields} />
      {!!Component && <Component {...rest} />}
      <DynamicConfigValues path={`auth_templates[${props.index}].config`} />
    </Section>
  );
};

const Explanation = () => {
  return (
    <div style={{ padding: 'var(--spacing-lg)' }}>
      <Typography variant="body2">
        The <code>auth_template[].config</code> is the authentication template formula that
        admin-api uses for generating a <code>data_credential</code> object. <br />
        Key-values in this section should match the key-values that are needed inside a{' '}
        <strong>Rest</strong> connector <code>data_credential</code> object.
        <br />
        <br />
        <strong>Note:</strong> Sometimes we want user to input a field that is used not only during
        credential creation, but also as part of endpoint template for source/sink creation.
        <br />
        For ex: User needs to enter the Mailchimp Data Center url they need to connect to as a macro
        <em>mailchimp_api.dc</em>, and that input is to be used for all source/sink endpoints.
        <br />
        In that case, remember that auth_template params are not available to endpoints. So in order
        to solve this problem:
        <ol>
          <li>
            Create a key in this config object that reflects the macro name of the param you want.
            In this case, add "mailchimp_api.dc":"$&#123;mailchimp_api.dc&#125;" to the config
            object.
          </li>
          <li>
            In the source/sink endpoint, use backend macro{' '}
            &#123;data_credentials['mailchimp_api.dc']&#125; wherever you need this credential
            property.
          </li>
        </ol>
      </Typography>
    </div>
  );
};
